/**
 * The image widths the CMS image resizer accepts (`ImageProtection:AllowedSizes`
 * in the backend). Every other width is rounded up by the backend, but still
 * misses the Front Door cache, so the frontend only requests these widths:
 * `next/image` through `images.imageSizes` and `images.deviceSizes` in each
 * app's `next.config.js`, and `formatImageUrl` by rounding up to them.
 *
 * Keep in sync with the backend list.
 */

/** Widths for images smaller than the viewport (used with `sizes`) */
const IMAGE_SIZES = [64, 128, 256, 384, 512];

/** Widths for full-width and large images */
const DEVICE_SIZES = [640, 800, 1024, 1280, 1600, 1920, 2560];

module.exports = { DEVICE_SIZES, IMAGE_SIZES };
